'use strict';

var w3cCredentialStatus = require('@trustvc/w3c-credential-status');
var helper = require('../../helper');
var w3cVc = require('../../w3c-vc');

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const verifyCredentialStatus = /* @__PURE__ */ __name(async (credentialStatus, type = "StatusList2021Entry", options) => {
  try {
    helper._checkCredentialStatus(credentialStatus, "verify");
    if (![
      "BitstringStatusListEntry",
      "StatusList2021Entry"
    ].includes(type)) {
      return {
        error: "Invalid credential status type. Expected BitstringStatusListCredentialStatus"
      };
    }
    const { statusPurpose, statusListIndex, statusListCredential } = credentialStatus ?? {};
    const index = Number.parseInt(statusListIndex);
    const vcStatusList = await w3cCredentialStatus.fetchCredentialStatusVC(statusListCredential, options?.documentLoader);
    const statusList = vcStatusList.credentialSubject;
    w3cCredentialStatus.assertStatusPurposeMatches(statusList, statusPurpose);
    const bitstringStatusList = await w3cCredentialStatus.StatusList.decode(statusList);
    w3cCredentialStatus.assertStatusListIndexWithinRange(bitstringStatusList, index);
    const vcStatusListVerificationResult = await w3cVc.verifyCredential(vcStatusList, options);
    if (!vcStatusListVerificationResult?.verified) {
      console.error(`Failed to verify Credential Status VC: ${vcStatusListVerificationResult.verified}. Error: ${vcStatusListVerificationResult.error}`);
      throw new Error(`Failed to verify Credential Status VC: ${vcStatusListVerificationResult.verified}`);
    }
    const status = bitstringStatusList.getStatus(index);
    return {
      status,
      purpose: statusPurpose
    };
  } catch (err) {
    if (!(err instanceof Error)) {
      return {
        error: "An error occurred while verifying the credential status."
      };
    }
    if (err.message.includes("Could not decode encoded status list; reason:")) {
      return {
        error: `Invalid encodedList: encodedList cannot be decoded`
      };
    }
    return {
      error: err.message
    };
  }
}, "verifyCredentialStatus");

exports.verifyCredentialStatus = verifyCredentialStatus;
